import _DatabaseModel from "./_DatabaseModel";
import { mdiEyeOutline, mdiEyeOffOutline } from "@mdi/js";

class Snippet extends _DatabaseModel {
  static model = "snippet";
  static editDialogComponent = "snippets-edit-dialog";

  static tableHeaders = [
    { textKey: "form.label.name", value: "name" },
    { textKey: "snippet.label.public", value: "public" },
  ];

  static show = {
    buttons: ["edit"],
    submenuActions: ["activity", "destroy"],
    reloadingModels: [],
  };

  static filter = {
    parts: {
      fields: ["name", "time_filter", "public"],
      extended_fields: [],
      time_filter: ["created_at", "updated_at"],
    },
  };

  static public_options = {
    true: "filter.public_levels.shared",
    false: "filter.public_levels.private",
  };

  static cardFields(object) {
    return {
      src: {
        cardIcon: object.public ? mdiEyeOutline : mdiEyeOffOutline,
        color: object.public ? "success" : "warning",
      },
      title: object.name,
    };
  }

  static basicInfo(object) {
    return [
      {
        labelKey: "snippet.label.public",
        value: object.public,
        type: "boolean",
      },
      {
        labelKey: "form.label.created_at",
        value: object.created_at,
        type: "date_time",
      },
    ];
  }

  static tabs = [this.detailTab];
}

export default Snippet;
